
import './App.css';
import React from 'react';
import MainPage from './components/home/MainPage';

function App() {
  return (
    <div className="App">
          <MainPage/>
    </div>
  );
}

export default App;
